module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Praise for Basil Sands")])]), _vm._v(" "), _c('p', {
    staticClass: "quotesnospacebelow"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "quotesnospacebelow"
  }, [_vm._v("“Sands is fearless in his storytelling, and tireless in his quest to connect directly with his audience.”")]), _vm._v(" "), _c('p', {
    staticClass: "quote-name"
  }, [_vm._v("—Scott Sigler, "), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("NYT ")]), _vm._v("Bestselling Author")]), _vm._v(" "), _c('p', {
    staticClass: "quotesnospacebelow"
  }, [_vm._v("“Basil Sands is one awesome writer, penning stories pumped with enough adrenaline that you’ll suffer from insomnia until you read the last word. This is one writer not to be missed.”")]), _vm._v(" "), _c('p', {
    staticClass: "quote-name"
  }, [_vm._v("—Jeremy Robinson, International Bestselling Author")]), _vm._v(" "), _c('p', {
    staticClass: "quotesnospacebelow"
  }, [_vm._v("“Basil Sands has a knack for blending action and intrigue in an all-too realistic setting…I just hope there are heroes like Basil’s heroes fighting on our side.”")]), _vm._v(" "), _c('p', {
    staticClass: "quote-name"
  }, [_vm._v("—Evo Terra, founder of Podiobooks.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136438ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Midnight_Sun_v2.vue
// module id = 60
// module chunks = 0